import axios, { AxiosResponse } from 'axios'
import { QueryFunction } from 'react-query'

export const all: QueryFunction<AxiosResponse<any[]>, [string, number]> = ({ queryKey: [ , id ] }) => axios.get(`reportments/${id}/charts`)
